import React, { useState } from 'react';
import { useDrag, useDrop } from 'react-dnd';

import UserPool from "../UserPool";
import { CognitoUserAttribute, CognitoUser } from 'amazon-cognito-identity-js';
import { useNavigate } from 'react-router-dom';
import ItemListProyects from '../components/ItemListProyects';

import HeaderLogin from '../components/HeaderLogin';
import { Footer } from '../components/FooterLogin';

const Dashboar = () => {

    return (
          <div className="app">
            <HeaderLogin/>            
              <ItemListProyects />
            <Footer/>
          </div>
    );
};

export default Dashboar;
